import { ReactComponent as SVGLogo } from 'images/lune-logo.svg'

import styles from './SVGLogo.module.css'

const SVGLuneLogo = ({ className }: { className?: string }) => {
    return <SVGLogo className={` ${className || ''} ${styles.Logo}`} />
}

export default SVGLuneLogo
